import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageTitle } from "./AdminApp";

const Stat = ({ label, value, to, accent = "border-l-amber-500", testid }) => (
  <Link to={to} data-testid={testid} className={`rounded-lg border border-neutral-800 border-l-4 ${accent} bg-neutral-900 p-5 transition-transform duration-200 hover:-translate-y-0.5`}>
    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-500">{label}</p>
    <p className="mt-2 font-display text-4xl font-bold text-neutral-50">{value}</p>
  </Link>
);

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data));
  }, []);
  if (!s) return <p className="text-neutral-500">Loading…</p>;
  return (
    <div data-testid="admin-dashboard">
      <PageTitle title="Dashboard" />
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Stat testid="stat-registrations" label="Households" value={s.registrations} to="/admin/registrations" />
        <Stat testid="stat-people" label="People expected" value={s.people} to="/admin/attendance" accent="border-l-emerald-600" />
        <Stat testid="stat-volunteers" label="Volunteers" value={s.volunteers} to="/admin/volunteers" accent="border-l-emerald-600" />
        <Stat testid="stat-contacts" label="Messages" value={s.contacts} to="/admin/contacts" accent="border-l-red-700" />
        <Stat testid="stat-donations-pending" label="Awaiting payment" value={s.donations_by_status.pending_payment || 0} to="/admin/donations" accent="border-l-red-700" />
        <Stat testid="stat-donations-paid" label="Donations received" value={`$${s.paid_total.toFixed(2)}`} to="/admin/donations" />
        <Stat testid="stat-giveaway" label="Giveaway entries" value={s.giveaway_entries} to="/admin/giveaway" accent="border-l-emerald-600" />
        <Stat testid="stat-optins" label="Future opt-ins" value={s.opt_ins} to="/admin/registrations" accent="border-l-red-700" />
        <Stat testid="stat-vendors" label={`Vendors${s.vendors_new ? ` · ${s.vendors_new} new` : ""}`} value={s.vendors} to="/admin/vendors" />
      </div>
      <h2 className="mb-3 mt-10 font-display text-xl text-neutral-200">By day</h2>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {s.per_day.map((d) => (
          <div key={d.day} className="rounded-lg border border-neutral-800 bg-neutral-900 p-5" data-testid={`dashboard-day-${d.day}`}>
            <p className="font-display text-lg text-gold">{d.label}</p>
            <p className="mt-2 text-sm text-neutral-400">
              <b className="text-neutral-100">{d.planned_households}</b> households · <b className="text-neutral-100">{d.planned_people}</b> people planned
            </p>
            <p className="mt-1 text-sm text-emerald-400">{d.checked_in} checked in</p>
          </div>
        ))}
      </div>
    </div>
  );
}
